<template>
  <div>
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="合同编号" prop="contractNo">
        <el-input v-model="form.contractNo"></el-input>
      </el-form-item>
      <el-form-item label="采购数量" prop="Number">
        <el-input v-model="form.Number"></el-input>
      </el-form-item>
      <el-form-item label="采购单价" prop="UnitPrice">
        <el-input v-model="form.UnitPrice"></el-input>
      </el-form-item>
      <el-form-item label="采购总价" prop="Totalprice">
        <el-input v-model="form.Totalprice"></el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input v-model="form.Remarks" type="textarea"></el-input>
      </el-form-item>
      <el-col :span="11">
        <el-form-item label="采购日期">
          <el-date-picker
            v-model="form.date"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </el-form-item>
      </el-col>
      <el-button type="primary" @click="Purchaseform('form')">创建</el-button>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      form: {
        Number: "",
        UnitPrice: "",
        Totalprice: "",
        date: "",
        contractNo: "",
        Remarks: "",
      },
      rules: {
        contractNo: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: "blur",
          },
        ],
        Number: [
          { required: true, message: "请输入采购数量", trigger: "blur" },
          { min: 1, max: 3, message: "长度在 1 到 3 个字符", trigger: "blur" },
        ],
        Totalprice: [
          { required: true, message: "请输入采购总价", trigger: "blur" },
          { min: 1, max: 6, message: "长度在 1 到 6 个字符", trigger: "blur" },
        ],
        UnitPrice: [
          { required: true, message: "请输入采购单价", trigger: "blur" },
          { min: 1, max: 6, message: "长度在 1 到 6 个字符", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    Purchaseform(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          let formData = new FormData();
          formData.append("remark", this.form.Remarks);
          formData.append("contractNo", this.form.contractNo);
          formData.append("amount", this.form.Number);
          formData.append("unitPrice", this.form.UnitPrice);
          formData.append("totalPrice", this.form.Totalprice);
          formData.append("purchaseDate", this.form.date);
          this.$http
            .post(
              this.$getaxiosurl("/enc/purchase/createPurchaseContract"),
              formData
            )
            .then((response) => {
              if (response.data.code == "00100") {
                this.jiamisuoid = response.data.id;
                this.$message({
                  message: "创建成功",
                  type: "success",
                  duration: 8000,
                });
                this.jiamisuo = true;
              }
              if (response.data.code !== "00100") {
                this.$message({
                  message: response.data.msg,
                  type: "error",
                  showClose: true,
                });
              }
            });
        }
      });
    },
  },
};
</script>
<style>
</style>
